import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Button from '../Button';

const sectionOrder = [
  'Applicant Information',
  'Family Information',
  'Emergency Contact Information',
  'Student Educational Background',
  'Academic & Personal Interests',
  'Additional Information',
  'Technology Access',
  'Transcript Upload',
  'Signature & Acknowledgment',
];

const fieldLabels = {
  studentFullName: 'Full Legal Name',
  studentPreferredName: 'Preferred Name',
  studentDOB: 'Date of Birth',
  studentCurrentGrade: 'Current Grade Level',
  studentApplyingGrade: 'Grade Level Applying For',
  studentEmail: 'Applicant Email',
  studentPhone: 'Applicant Phone Number',
  parent1FullName: 'Parent/Guardian #1 Name',
  parent1Relationship: 'Parent/Guardian #1 Relationship',
  parent1Email: 'Parent/Guardian #1 Email',
  parent1Phone: 'Parent/Guardian #1 Phone',
  parent1Address: 'Parent/Guardian #1 Address',
  parent1Occupation: 'Parent/Guardian #1 Occupation',
  parent1Employer: 'Parent/Guardian #1 Employer',
  parent2FullName: 'Parent/Guardian #2 Name',
  parent2Relationship: 'Parent/Guardian #2 Relationship',
  parent2Email: 'Parent/Guardian #2 Email',
  parent2Phone: 'Parent/Guardian #2 Phone',
  parent2Address: 'Parent/Guardian #2 Address',
  parent2Occupation: 'Parent/Guardian #2 Occupation',
  parent2Employer: 'Parent/Guardian #2 Employer',
  emergencyName: 'Emergency Contact Name',
  emergencyRelationship: 'Emergency Contact Relationship',
  emergencyPrimaryPhone: 'Emergency Primary Phone',
  emergencyAlternatePhone: 'Emergency Alternate Phone',
  emergencySameAsParent1: 'Emergency Contact Same as Parent 1',
  schoolName: 'Current/Most Recent School',
  schoolDates: 'Dates Attended',
  schoolReason: 'Reason for Leaving/Transfer',
  academicStrengths: 'Academic Strengths',
  hobbies: 'Hobbies/Interests',
  interestInDual: 'Interest in Dual School',
  specialNeeds: 'Special Needs/Accommodations',
  techComputer: 'Has Daily Computer Access',
  techInternet: 'Has Reliable Internet Access',
  transcriptFiles: 'Transcript Files',
  parentSignature: 'Parent/Guardian Signature',
  studentSignature: 'Student Signature',
  parentSignatureDate: 'Parent Signature Date',
  studentSignatureDate: 'Student Signature Date',
};

const ParentApplicationSummary = () => {
  const [sections, setSections] = useState([]);
  const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

  useEffect(() => {
    const fetchApplication = async () => {
      const token = localStorage.getItem('token');
      try {
        const res = await axios.get(`${API_ENDPOINT}/api/application/`, {
          headers: { Authorization: `Token ${token}` },
        });
        const app = res.data;
        if (app && app.form_data && Array.isArray(app.form_data)) {
          // Sort and flatten sections by order
          const sortedSections = sectionOrder.map((title) =>
            app.form_data.find((s) => s.title === title)
          ).filter(Boolean);
          setSections(sortedSections);
        }
      } catch (err) {
        setSections([]);
      }
    };
    fetchApplication();
  }, [API_ENDPOINT]);

  return (
    <div className="page-container" style={{ maxWidth: 800, margin: '0 auto', background: '#fff', padding: 32, borderRadius: 8 }}>
      <h1>Application Summary</h1>
      {sections.length === 0 ? (
        <p>No application data found.</p>
      ) : (
        <>
          {sections.map((section, idx) => (
            <div key={section.title} style={{ marginBottom: 32 }}>
              <h2 style={{ fontSize: 20, fontWeight: 600, marginBottom: 12 }}>{idx + 1}. {section.title}</h2>
              <table style={{ width: '100%', borderCollapse: 'collapse', background: '#fafbfc' }}>
                <tbody>
                  {Object.entries(section.data).map(([key, value]) => (
                    <tr key={key}>
                      <td style={{ fontWeight: 500, padding: '6px 12px', border: '1px solid #eee', width: 260 }}>{fieldLabels[key] || key}</td>
                      <td style={{ padding: '6px 12px', border: '1px solid #eee' }}>{Array.isArray(value) ? value.join(', ') : value === true ? 'Yes' : value === false ? 'No' : value}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ))}
        </>
      )}
      <Button variant="primary" onClick={() => window.history.back()} style={{ marginTop: 24 }}>Back</Button>
    </div>
  );
};

export default ParentApplicationSummary; 